<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20 20H0V0H20V20ZM1.25 18.75H18.75V1.25H1.25V18.75Z"
    fill="currentColor"
/>
<path
    d="M12.2046 6.96615L17.9256 7.42513L13.5661 11.1589L14.8983 16.7415L10 13.75L5.10173 16.7415L6.43392 11.1589L2.07438 7.42513L7.79541 6.96615L10 1.66667L12.2046 6.96615ZM8.65641 8.15104L5.17008 8.43018L7.82633 10.7064L7.01497 14.1081L10 12.2852L12.9842 14.1081L12.1737 10.7064L14.8291 8.43018L11.3436 8.15104L10 4.92106L8.65641 8.15104Z"
    fill="currentColor"
/>
<path
    d="M9.9998 1.67969V13.7533L9.9941 13.75L5.09583 16.7415L6.42721 11.1589L2.06848 7.42513L7.78951 6.96615L9.9941 1.66667L9.9998 1.67969Z"
    fill="currentColor"
/>
